import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';

type EmptyStateProps = {
  title?: string;
  description: string;
  image?: React.ReactNode;
  action?: string;
};

export const EmptyState = ({ title, description, image, action }: EmptyStateProps) => {
  return (
    <section css={containerStyles}>
      {image}
      {title && (
        <Heading as='h3' textAlign='center' css={{ fontSize: theme.fontSize(24), marginTop: theme.spacing(2) }}>
          {title}
        </Heading>
      )}
      <Text textAlign='center' color='subdued'>
        {description}
      </Text>
      {action && (
        <Button variant='primary' css={{ marginTop: theme.spacing(2) }}>
          {action}
        </Button>
      )}
    </section>
  );
};

const containerStyles = css({
  margin: 'auto',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  maxWidth: 400,
  justifySelf: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
});
